import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  FormControl,
  Grid,
  InputLabel,
  LinearProgress,
  Typography
} from '@material-ui/core';
import {
  Event as CalendarIcon,
  KeyboardArrowLeft as ArrowLeftIcon,
  KeyboardArrowRight as ArrowRightIcon
} from '@material-ui/icons';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import { DatePicker } from 'material-ui-pickers';
import { Duration, AutoComplete } from '../layout';
import InfiniteScroll from 'react-infinite-scroller';
import moment from 'moment';
import filesize from 'filesize';

const cardStyle = theme => ({
  filters: {
    flexGrow: 1,
    marginTop: 10,
    marginLeft: 0,
    marginBottom: 15
  },
  filter: {
    [theme.breakpoints.up('sm')]: {
      minHeight: 85
    },
    minWidth: 150
  },
  button: {
    marginTop: 12
  },
  datePicker: {
    marginRight: 20,
    width: 150
  },
  card: {
    margin: 5,
    padding: 0
  },
  cardContent: {
    padding: 10
  },
  caption: {
    display: 'inline-block',
    marginRight: 2
  },
  field: {
    fontSize: '0.7em'
  },
  thumb: {
    height: 150
  },
  paper: {
    top: '100%'
  }
});

const VideoList = class extends Component {
  searchVideos = () => {
    return this.props.searchVideos();
  };

  loadDevices = () => {
    this.props.loadDevices();
  };

  nextVideos = () => {
    if (!this.props.fetching) {
      if (!this.props.data) {
        // first time, called automatically by InfiniteScroll component
        // search videos instead
        return this.searchVideos();
      }
      return this.props.nextVideos();
    }
  };

  componentDidMount = () => {
    this.loadDevices();
  };

  render = () => {
    const {
      classes,
      startDate,
      endDate,
      sort,
      devices,
      device,
      data,
      fetching,
      fetchError,
      hasMoreItems,
      handleStartDate,
      handleEndDate,
      handleSort,
      handleDevice
    } = this.props;
    const keyboardIcon = <CalendarIcon />;
    const leftArrowIcon = <ArrowLeftIcon />;
    const rightArrowIcon = <ArrowRightIcon />;
    const sortOptions = [
      {
        value: '-startTime',
        label: 'Date (newest)'
      },
      {
        value: 'startTime',
        label: 'Date (oldest)'
      }
    ].map(sort => ({
      value: sort.value,
      label: sort.label
    }));

    return (
      <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
        <Fragment>
          <Grid container spacing={16} className={classes.filters}>
            <Grid item className={classes.filter}>
              <DatePicker
                className={classes.datePicker}
                autoOk
                keyboard
                showTodayButton
                label="From"
                format="MM/DD/YYYY"
                value={startDate}
                onChange={handleStartDate}
                keyboardIcon={keyboardIcon}
                leftArrowIcon={leftArrowIcon}
                rightArrowIcon={rightArrowIcon}
              />
            </Grid>
            <Grid item className={classes.filter}>
              <DatePicker
                className={classes.datePicker}
                autoOk
                keyboard
                showTodayButton
                label="To"
                format="MM/DD/YYYY"
                value={endDate}
                onChange={handleEndDate}
                keyboardIcon={keyboardIcon}
                leftArrowIcon={leftArrowIcon}
                rightArrowIcon={rightArrowIcon}
              />
            </Grid>
            <Grid item className={classes.filter}>
              <FormControl>
                <InputLabel htmlFor="sort" shrink={true}>
                  Sort
                </InputLabel>
                <AutoComplete
                  isSearchable={false}
                  backspaceRemovesValue={false}
                  value={sort}
                  options={sortOptions}
                  onChange={handleSort}
                />
              </FormControl>
            </Grid>
            <Grid item className={classes.filter}>
              <FormControl>
                <InputLabel htmlFor="device" shrink={true}>
                  Device
                </InputLabel>
                <AutoComplete
                  isClearable
                  isSearchable
                  backspaceRemovesValue
                  value={device}
                  options={devices}
                  onChange={handleDevice}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <Button
                variant="raised"
                component="span"
                color="primary"
                className={classes.button}
                onClick={this.searchVideos}
              >
                Apply
              </Button>
            </Grid>
          </Grid>
          <InfiniteScroll
            pageStart={0}
            loadMore={this.nextVideos}
            hasMore={Boolean(!fetching && !fetchError && hasMoreItems)}
          >
            <Grid container spacing={8} direction="row">
              {data &&
                data.map(item => (
                  <Grid item lg={2} md={3} key={item.id}>
                    <Card className={classes.card}>
                      {item.thumb && (
                        <Link to={`/library/${item.id}`}>
                          <CardMedia
                            className={classes.thumb}
                            image={`https://content.dev.alulavideo.net/${
                              item.thumb
                            }`}
                          />
                        </Link>
                      )}
                      <CardContent className={classes.cardContent}>
                        <Typography variant="body1" className={classes.field}>
                          <Link to={`/library/${item.id}`}>
                            <Typography
                              variant="caption"
                              className={classes.caption}
                            >
                              Device:
                            </Typography>
                            {item.device.serialNumber}
                          </Link>
                        </Typography>
                        <Typography variant="body1" className={classes.field}>
                          <Typography
                            variant="caption"
                            className={classes.caption}
                          >
                            Start:
                          </Typography>
                          {item.startTime &&
                            moment(item.startTime).format('L LT')}
                        </Typography>
                        <Typography variant="body1" className={classes.field}>
                          <Typography
                            variant="caption"
                            className={classes.caption}
                          >
                            End:
                          </Typography>
                          {item.endTime && moment(item.endTime).format('L LT')}
                        </Typography>
                        <div style={{ display: 'flex' }}>
                          <div>
                            <Typography className={classes.field}>
                              <Duration length={item.length} />
                            </Typography>
                          </div>
                          <div style={{ flex: 1 }}>
                            <Typography className={classes.field} align="right">
                              {item.size && filesize(item.size)}
                            </Typography>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
            </Grid>
          </InfiniteScroll>
          {fetching && <LinearProgress />}
        </Fragment>
      </MuiPickersUtilsProvider>
    );
  };
};
export default withStyles(cardStyle)(VideoList);



// WEBPACK FOOTER //
// ./src/components/pages/VideoList.js